import { containerStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

Object.assign(containerStyles, {
    fulfillmentMethodAndAddressesContainer: {
        css: css`
            > ${GridOffset} {
                width: calc(100% + 30px) !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 100% !important;
                                margin: 0;
                            `,
                            css`
                                width: 100% !important;
                                margin: 0;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
    notesAndCartTotalGridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-height: 0px;
                    `,
                    css`
                        min-height: 0px;
                    `,
                    css`
                        min-height: 400px;
                    `,
                    css`
                        min-height: 400px;
                    `,
                    css`
                        min-height: 400px;
                    `,
                ])}
        `,
    },
    notesAndCartTotalContainer: {
        css: css`
            position: sticky;
            top: 110px;
        `,
    },
    headerGridItem: {
        css: css`
            display: none;
        `,
    },
    container: {
        css: css`
            margin-bottom: 30px;
            > ${GridOffset} {
                width: calc(100% + 12px);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                width: calc(100% + 30px);
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
});
